import confirm from '@/v-ui/Confirm';
import toast from '@/v-ui/Toast';
import { INTERFACE } from '@/utils/INTERFACE';
import http from '@/utils/http';
import { getPlatform } from '@/utils/page';
import translate from '@/utils/translate';
import Cookies from 'js-cookie'
import { getSystem } from '@/utils/site'
import { getParams } from '@/utils/zgb'

export async function addCart(sku) {
    var { platform } = getPlatform()
    var sys = getSystem()
    if (sys == 'th') {
        let res = await http.jsonp.get(INTERFACE().addCart, {
            locationId: Cookies.get("areaIds"),
            itemList: JSON.stringify([{ "skuId": sku, "itemType": 1, "num": 1 }]),
            presellFlag: false
        })
        if (res.code == 'success' && res.data.flag) {
            if (platform == 'mob') {
                toast(translate("Items Successfully Added"))
            } else {
                confirm.success(translate("Items Successfully Added"), {
                    buttons: `<a target="_blank" href="//cart.jd.co.th"><button>${translate('Check Out')}</button></a><button class="close flat">${translate('Continue Shopping')}</button>`,
                    modal: true
                })
            }
        } else {
            if (platform == 'mob') {
                toast(translate("Items Add Failed"))
            } else {
                confirm.warning(translate("Items Add Failed"), { modal: true })
            }
        }
    }
    if (sys == 'EJSHOP') {
        let res = await http.jsonp.get(INTERFACE().addCart, getParams({
            "operate": "2",
            "skus": [
                {
                    id: sku,
                    num: 1
                }
            ]
        }))
        if (res.data.success) {
            toast(translate("Items Successfully Added"))
        } else {
            toast(res.data.msg || res.data.message)
        }
    }

}